/**
 * Devuelve la clase de icono Remix Icon según la extensión del archivo o la URL.
 * Usado para mostrar iconos de Word, Excel, PowerPoint, PDF, etc.
 * @param {string} fileNameOrUrl - Nombre del archivo (ej. "documento.pdf") o URL del archivo
 * @returns {string} Clase CSS del icono (ej. "ri-file-pdf-fill")
 */
export function getFileIconClass(fileNameOrUrl) {
	if (!fileNameOrUrl || typeof fileNameOrUrl !== "string") return "ri-file-text-fill";
	const lower = fileNameOrUrl.toLowerCase();
	let ext = "";
	const lastSlash = lower.lastIndexOf("/");
	const lastDot = lower.lastIndexOf(".");
	if (lastDot > -1 && (lastSlash === -1 || lastDot > lastSlash)) {
		ext = lower.slice(lastDot);
	}
	const map = {
		".pdf": "ri-file-pdf-2-fill",
		".doc": "ri-file-word-fill",
		".docx": "ri-file-word-fill",
		".odt": "ri-file-word-fill",
		".rtf": "ri-file-word-fill",
		".xls": "ri-file-excel-fill",
		".xlsx": "ri-file-excel-fill",
		".ods": "ri-file-excel-fill",
		".csv": "ri-file-excel-fill",
		".ppt": "ri-file-ppt-fill",
		".pptx": "ri-file-ppt-fill",
		".odp": "ri-file-ppt-fill",
		".txt": "ri-file-text-fill",
		".zip": "ri-file-zip-fill",
		".rar": "ri-file-zip-fill",
		".jpg": "ri-file-image-fill",
		".jpeg": "ri-file-image-fill",
		".png": "ri-file-image-fill",
		".gif": "ri-file-image-fill",
		".webp": "ri-file-image-fill",
		".mp4": "ri-file-video-fill",
		".webm": "ri-file-video-fill",
		".mp3": "ri-file-music-fill",
	};
	return map[ext] || "ri-file-text-fill";
}

/**
 * Indica si el recurso es de tipo "solo ver enlace" (clases virtuales): no se ofrece descarga.
 */
export function isLinkOnlyCategory(category) {
	return category === "clases";
}
